export default "assets/images/icons/youtube-97069052.svg";